import React from "react"

import "./section-redeem-points.scss"
import Button from "../../../shared/components/atoms/button/button"
import TipsRedeemItem from "../../atoms/tips-redeem-item/tips-redeem-item"
import {
  getTextButtonLearnHow,
  getTextFourRedeemYourPoints,
  getTextOneRedeemYourPoints,
  getTextThreeRedeemYourPoints,
  getTextTwoRedeemYourPoints,
} from "../../../utils/getPointMessages"
import { buttonClickTransversal } from "../../../utils/loyaltyDatalayer"
import { withBottomLine } from "../../../shared/utils/formatString"

const SectionRedeemPoints = props => {

  const { mobile, setIsRedeemInfo, isLogin, category = "mis_puntos" } = props

  const handleClick = (e) => {
    e.preventDefault()
    buttonClickTransversal({
      category: withBottomLine(category),
      label: getTextButtonLearnHow(process.env.LOCALE)
    });
    setIsRedeemInfo(true)
  }

  const isPeru = process.env.LOCALE === "es-PE"
  const isPuertoRico = process.env.LOCALE === "es-PR"
  const isColombia = process.env.LOCALE === "es-CO"
  const isArgentina = process.env.LOCALE === "es-AR"
  const isChile = process.env.LOCALE === "es-CL";

  const tipsImage1 = (() => {
    if (isArgentina) {
      return require("../../../assets/images/performance/redime-tus-puntos-1-AR.webp");
    }
    if (isChile) {
      return require("../../../assets/images/performance/redime-tus-puntos-1-CL.webp");
    }

    return require("../../../assets/images/performance/redime-tus-puntos-1.webp");
  })();
  return (
    <div className={"f-section-redeem-points-container" + (isLogin ? " f-back-login" : "")}>
      <div className="f-section-redeem-points-container-wrap">
        <div className="f-info-container">
          <div className="f-info-container-title">
            {isArgentina ?
              <h2>Canjeá tus puntos</h2>
              :
              isChile ?
                <h2>Canjea tus puntos</h2>
                :
                <h2>Redime tus puntos</h2>
            }
          </div>
          <ol className="f-info-container-flex">
            <TipsRedeemItem
              mobile={mobile}
              imgUrl={tipsImage1}
              description={getTextOneRedeemYourPoints(process.env.LOCALE)}
            />
            <TipsRedeemItem
              mobile={mobile}
              imgUrl={isArgentina ? require("../../../assets/images/performance/redime-tus-puntos-2-AR.webp") : require("../../../assets/images/performance/redime-tus-puntos-2.webp")}
              description={getTextTwoRedeemYourPoints(process.env.LOCALE)}
            />
            <TipsRedeemItem
              mobile={mobile}
              imgUrl={require("../../../assets/images/performance/redime-tus-puntos-3.webp")}
              description={getTextThreeRedeemYourPoints(process.env.LOCALE)}
            />
            <TipsRedeemItem
              mobile={mobile}
              imgUrl={require("../../../assets/images/performance/redime-tus-puntos-4.webp")}
              description={getTextFourRedeemYourPoints(process.env.LOCALE)}
            />
          </ol>
          {!isPeru && <Button
            className="primary-pink"
            title={getTextButtonLearnHow(process.env.LOCALE)}
            onClick={handleClick}
          />}
        </div>
      </div>
      <span className={"f-curve-effect-end-section" + (isLogin ? " f-back-curve-login" : " f-back-curve")}>
        <span className="f-curve-effect-end-section-child" />
      </span>
    </div>
  )
}

export default SectionRedeemPoints
